import * as React from 'react';

export const PauseIconOutline: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M6.75 21c-1.241 0-2.25-1.009-2.25-2.25V5.25C4.5 4.009 5.509 3 6.75 3h1.5c1.241 0 2.25 1.009 2.25 2.25v13.5c0 1.241-1.009 2.25-2.25 2.25H6.75zM6.75 4.5C6.336 4.5 6 4.836 6 5.25v13.5c0 .414.336.75.75.75h1.5C8.664 19.5 9 19.164 9 18.75V5.25C9 4.836 8.664 4.5 8.25 4.5H6.75zM15.75 21c-1.241 0-2.25-1.009-2.25-2.25V5.25C13.5 4.009 14.509 3 15.75 3h1.5c1.241 0 2.25 1.009 2.25 2.25v13.5c0 1.241-1.009 2.25-2.25 2.25H15.75zM15.75 4.5C15.336 4.5 15 4.836 15 5.25v13.5c0 .414.336.75.75.75h1.5c.414 0 .75-.336.75-.75V5.25c0-.414-.336-.75-.75-.75H15.75z"
    />
  </svg>
);
